import { sub } from 'date-fns';
import { today } from '../../../utils/date';
import { EQueryParameters as EPeriod } from 'shared/repositories/valuation-offer-history/v1/get-market-trand';

export function useGetMinDate(period: EPeriod) {
  switch (period) {
    case EPeriod.OneYear:
      return +sub(today(), { years: 1 });
    case EPeriod.SixMonths:
      return +sub(today(), { months: 6 });
    default:
      return +sub(today(), { years: 5 });
  }
}
